import { ContainerModule } from 'inversify';
import FileDownloadLinkGenerator from './FileDownloadLinkGenerator';

export const FileDownloadLinkGeneratorModule = new ContainerModule(({ bind }) => {
  bind(FileDownloadLinkGenerator).toSelf().inSingletonScope();
});
